import { Label } from '../../components/Label';
import { useCreateOperator } from '../../contexts/CreateOperatorContext';
import React from 'react';
import { HomeWork } from '@material-ui/icons';

interface Props {
  canShow: boolean;
}

export const StickyHeader = ({ canShow }: Props) => {
  const { operator } = useCreateOperator();

  if (canShow === false) return null;

  return (
    <div className="sticky -top-12 z-20 grid grid-cols-5 grid-rows-1 gap-4 items-end px-1 py-3 w-full border-b-2 border-primary bg-background-light dark:bg-background-dark">
      <h2 className="text-xl align-text-baseline">
        <span>
          <HomeWork fontSize="large" />
        </span>{' '}
        Operator
      </h2>
      <div className="inline-flex items-center justify-center gap-4 col-span-3">
        <Label text="Operator ID:">{operator.id || 'N/A'}</Label>
        <Label text="Operator Name:">{operator.name || 'N/A'}</Label>
        <Label text="Operator Code:">{operator.code || 'N/A'}</Label>
      </div>
    </div>
  );
};
